<template>
  <div class="page-opportunities-form" v-loading.fullscreen="loading" id="top">

    <div v-for="(block, index) in blocks" :key="`block-${index}`">
      <info-block :data="block"></info-block>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-main">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <el-button class="inline-middle is-gap-large-top"
            v-if="isDevOrLocal"
            type="info" @click="onFill" style="margin-left:15px;" size="mini">
            Auto Fill (Debug)
          </el-button>

          <div class="is-gap-xlarge">
            <formm
              ref="form"
              :form="form"
              :rules="formRules"
              :columns="formColumns"
              :data="formData">
            </formm>
          </div>

        </div>
      </div>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-ref">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="is-gap-xlarge">

            <h1>References</h1>
            <hr />
            <p>Kindly provide minimum ONE reference below.</p>

            <div class="is-gap-large-top is-gap-large-bottom"
              v-for="(formRef, findex) in formRefs" :key="`${findex}`"
              style="position:relative;">

              <hr v-if="parseInt(findex, 10) !== 0" class="is-gap-large-bottom" />

              <formm
                ref="formRef"
                :form="formRef"
                :findex="findex"
                :rules="formRef.rules"
                :columns="formRef.columns"
                :data="formData">
              </formm>

              <div>
                <el-button icon="el-icon-close"
                  class="button color-white-bg"
                  :style="(isDesktop ? {
                    position: 'absolute',
                    right: '26%',
                    top: 0,
                  } : {})"
                  v-if="formRefs.length > 1"
                  @click="onRemoveReference(parseInt(findex, 10))">
                </el-button>
              </div>
            </div>

            <el-button class="button color-green-bg"
              @click="onAddReference" v-if="!formRefs || formRefs.length < 3">
              Add More Reference
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="container is-gap-top color-lightgreen-bg" data-aos="fade-in" data-aos-once="true" id="top-upload">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="is-gap-xlarge">

            <h1>Upload Resume</h1>
            <hr />

            <formm
              ref="formUpload"
              fname="formUpload"
              :form="formUpload"
              :rules="formUploadRules"
              :columns="formUploadColumns"
              :data="formData"
              @on-file-preview="onFilePreview"
              @on-file-exceed="onFileExceed"
              @on-file-change="onFileChange"
              @on-file-success="onFileSuccess">
            </formm>

            <!-- <div>
              {{ JSON.stringify(formUpload) }}
            </div>

            <el-button class="button color-green-bg"
              @click="onUpload"
              :disabled="!formUpload || !formUpload.files || formUpload.files.length <= 0">
              Test Upload
            </el-button> -->

          </div>
        </div>
      </div>
    </div>

    <div class="container is-gap-large-top is-gap-large-bottom" data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">
          <div class="is-gap-xlarge" style="margin-top:0;">
            <el-button class="button color-green-bg"
              @click="onSubmit">
              Submit Application
            </el-button>

            <div v-if="isValidateError"
              class="column is-full label"
              style="color:#F56C6C;font-size:12px;">
              * Form contains error, please kindly recheck.
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
import OpportunitiesFormConstants from '@/pages/opportunities/form/formconstants'
import Util from '@/util'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

import InfoBlock from '@/pages/base/infoblock'
import Formm from '@/base/form'

import File from '@/apis/file'
import Upload from '@/apis/upload'

export default {
  name: 'page-opportunities-form',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
    Formm,
  },
  data () {
    return {
      loading: false,
      isDesktop: true,
      isDevOrLocal: (Constants.isDev || Constants.isLocalhost),
      blocks: [],
      // form
      form: {},
      formRules: OpportunitiesFormConstants.Form.getValidators(this, {
        isRelocate: false,
        isProvidedService: false
      }),
      formColumns: OpportunitiesFormConstants.Form.COLUMNS,
      formData: {
        dataSelectYesNo: Constants.OPTIONS_YES_NO,
        optionsState: []
      },
      // form refs
      formRefs: [{}],
      formRefRules: {},
      // form upload
      formUpload: {
        files: [],
      },
      formUploadRules: OpportunitiesFormConstants.FormUpload.getValidators(this, {}),
      formUploadColumns: OpportunitiesFormConstants.FormUpload.COLUMNS,
      isValidateError: false,
      validateErrorSection: undefined,
    }
  },
  computed: {
    Util: function () {
      return Util
    },

    isRelocate: function () {
      return this.form.isRelocate === Constants.OptionsYesNo.YES
    },

    isProvidedService: function () {
      return this.form.isProvidedService === Constants.OptionsYesNo.YES
    },
  },
  watch: {
    'form.isRelocate': function () {
      OpportunitiesFormConstants.Form.updateEnablers(this, this.formColumns, this.form)
      this.setRules()
    },

    'form.isProvidedService': function () {
      OpportunitiesFormConstants.Form.updateEnablers(this, this.formColumns, this.form)
      this.setRules()
    },
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.clear()
    this.setRules()

    this.load()
    await this.refresh()
  },
  methods: {
    clear () {
      let keyinfos = OpportunitiesFormConstants.Form.KEYS
      let form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'form', form)

      keyinfos = OpportunitiesFormConstants.FormRef.getKeys(1)
      form = Util.request.getDefaults(keyinfos)
      form.keys = keyinfos
      form.columns = OpportunitiesFormConstants.FormRef.getColumns(1)
      form.rules = OpportunitiesFormConstants.FormRef.getValidators(this, 1)
      this.$set(this, 'formRefs', [form])

      keyinfos = OpportunitiesFormConstants.FormUpload.KEYS
      form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'formUpload', form)
    },

    load () {
      // this.$set(this.form, '')
      if (this.$route.query.field) {
        this.$set(this.form, 'field', this.$route.query.field)
      }

      let states = Util.common.states()
      states = _.map(states, (item) => {
        return {
          id: item,
          label: item
        }
      })
      this.$set(this.formData, 'optionsState', states)
    },

    setRules () {
      let params = {
        isRelocate: this.isRelocate,
        isProvidedService: this.isProvidedService,
      }
      let rules = OpportunitiesFormConstants.Form.getValidators(this, params)
      this.$set(this, 'formRules', rules)

      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) {
          this.$refs.form.clearValidate()
        }

        for (let f in this.$refs.formRef) {
          let formRef = this.$refs.formRef[f]
          if (formRef && formRef.clearValidate) {
            formRef.clearValidate()
          }
        }
      })
    },

    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'blocks', [])
      let data = await Site.infoNamedLike('page-placement-form')
      this.$set(this, 'blocks', data)
    },

    onFill () {
      let keyinfos = OpportunitiesFormConstants.Form.KEYS_FILL
      let form = Util.request.getDefaults(keyinfos)
      this.$set(this, 'form', form)

      for (let f in this.formRefs) {
        let fNo = parseInt(f, 10) + 1
        // let formRef = this.formRefs[f]
        let keyinfos = OpportunitiesFormConstants.FormRef.KEYS_FILL
        keyinfos = OpportunitiesFormConstants.FormRef.getKeys(fNo, keyinfos)
        let form = Util.request.getDefaults(keyinfos)
        _.map(form, (value, key) => {
          this.$set(this.formRefs[f], key, value)
        })
      }
    },

    onAddReference () {
      if (!this.formRefs) this.$set(this, 'formRefs', [])

      let nextIndex = (this.formRefs.length + 1)
      let keyinfos = OpportunitiesFormConstants.FormRef.getKeys(nextIndex)
      let form = Util.request.getDefaults(keyinfos)
      form.keys = keyinfos
      form.columns = OpportunitiesFormConstants.FormRef.getColumns(nextIndex)
      form.rules = OpportunitiesFormConstants.FormRef.getValidators(this, nextIndex)
      this.formRefs.push(form)
    },

    onRemoveReference (index) {
      this.formRefs.splice(index, 1)
    },

    // on file

    async onFilePreview (info) {
      // console.log('onFilePreview', info)
      if (info && info.file && info.file.url) {
        // window.open(info.file.url, '_blank')
        try {
          this.loading = true
          await File.download(info.file.url)
          this.loading = false
        } catch (error) {
          this.loading = false
          console.error('file download failed', error)
          // this.$message({
          //   message: `File download failed: ${error.message || error}`,
          //   type: 'error'
          // })
        }
      }
    },

    onFileExceed (info) {
      this.$message({
        message: `Files exceeded total limit (${info.fileList ? info.fileList.length : -1}).`,
        type: 'error'
      })
    },

    onFileChange (info) {
      this.cleartoleave = false
      console.log('-- form file change', info)

      // form
      let form = this.form
      if (info.fname && this[info.fname]) {
        form = this[info.fname]
      }

      let refForm = this.$refs.form
      if (info.fname && this.$refs[info.fname]) {
        refForm = this.$refs[info.fname]
      }

      let findex = info.findex
      if (typeof findex === 'number') {
        // form
        if (!Array.isArray(form) || findex >= form.length) {
          console.error('invalid file change form array')
          return
        }
        form = form[findex]

        // refForm
        if (!Array.isArray(refForm) || findex >= refForm.length) {
          console.error('invalid file change refForm array')
          return
        }
        refForm = refForm[findex]
      }

      if (form && info.field && info.fileList) {
        // console.log('-- upload form set', { field: info.field, fileList: info.fileList })
        this.$set(form, info.field, info.fileList)
      }

      if (refForm && info.field && refForm.validateField) {
        // console.log('-- upload refForm validate')
        refForm.validateField(info.field)
      }
    },

    onFileSuccess (info) {
      // this.$refs.form.validateField()
    },

    // validate / submit

    async validate () {
      let isValidateError = false
      this.validateErrorSection = undefined
      try {
        if (this.$refs.form && this.$refs.form.validate) {
          await this.$refs.form.validate()
        }
      } catch (error) {
        if (error !== false) throw error
        isValidateError = true
        if (!this.validateErrorSection) {
          this.validateErrorSection = 'main'
        }
      }

      if (this.$refs.formRef) {
        let formRefs = this.$refs.formRef
        if (typeof formRefs !== 'object') throw new Error('invalid form ref object')
        if (!Array.isArray(formRefs)) formRefs = [formRefs]
        for (let f in formRefs) {
          let formRef = formRefs[f]
          try {
            if (formRef && formRef.validate) {
              await formRef.validate()
            }
          } catch (error) {
            if (error !== false) throw error
            isValidateError = true
            if (!this.validateErrorSection) {
              this.validateErrorSection = 'ref'
            }
          }
        }
      }

      try {
        if (this.$refs.formUpload && this.$refs.formUpload.validate) {
          await this.$refs.formUpload.validate()
        }
      } catch (error) {
        if (error !== false) throw error
        isValidateError = true
        if (!this.validateErrorSection) {
          this.validateErrorSection = 'upload'
        }
      }

      if (isValidateError) {
        let returnFalse = false
        throw returnFalse
      }
    },

    async onUpload () {
      console.log('-- onUpload')
      try {
        this.loading = true
        await this.uploadFile()
        this.$alert('Uploaded successfully.', {
          type: 'success'
        })
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$message({
          message: `Upload failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async uploadFile () {
      let files = this.formUpload && this.formUpload.files
      if (!files || files.length <= 0) throw new Error('invalid files')

      const formData = new FormData()
      for (var i = 0; i < files.length; i++) {
        formData.append(`files[${i}]`, files[i].raw, files[i].name)
      }
      let response = await Upload.upload(formData)
      console.log('-- upload response', response)
      return response
    },

    async onSubmit () {
      try {
        this.loading = true
        await this.validate()

        let files = []
        if (this.formUpload.files &&
          this.formUpload.files.length > 0) {
          let response = await this.uploadFile()
          if (response && response.files) {
            files = response.files
          }
          console.log(`-- form.submit.files`, files)
        }

        let keyinfos = OpportunitiesFormConstants.Form.KEYS
        let form = Util.request.parseForm(keyinfos, this.form)
        form = _.assign({}, form)
        console.log(`-- form.submit.form`, form)
        for (let f in this.formRefs) {
          let formRef = this.formRefs[f]
          keyinfos = formRef.keys
          formRef = Util.request.parseForm(keyinfos, formRef)
          formRef = _.assign({}, formRef)
          console.log(`-- form.submit.ref#${f}`, formRef)
          form = _.assign(form, formRef, { files })
        }
        console.log('-- form.submit', form)
        let response = await Site.signup(form)
        console.log('-- form.submit.response', response)

        this.$alert('Thank you for your interest in Allied Instructional Services. Your resume has successfully been submitted. AIS will contact you with potential next steps.', {
          type: 'success'
        })

        // this.clear()
        // this.setRules()
        //
        // this.load()
        // await this.refresh()
        this.$router.push({ name: 'landing' })

        this.loading = false
      } catch (error) {
        this.loading = false
        this.isValidateError = (error === false)
        if (error === false) {
          let validateErrorSection = this.validateErrorSection
          let anchor = `#top${validateErrorSection ? `-${validateErrorSection}` : ''}`
          this.$scrollTo(anchor)
          return
        }
        this.$message({
          message: `Submit failed: ${error.message || error}`,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" src="../../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../../styles/app_setting.scss";

.page-opportunities-form {
}

</style>
